import { render, staticRenderFns } from "./GregorianCalendar.vue?vue&type=template&id=199136ca&scoped=true"
import script from "./GregorianCalendar.vue?vue&type=script&lang=js"
export * from "./GregorianCalendar.vue?vue&type=script&lang=js"
import style0 from "./GregorianCalendar.vue?vue&type=style&index=0&id=199136ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199136ca",
  null
  
)

export default component.exports